/**
 * @generated SignedSource<<9a2fcd86ebaeec132b0b74c356b3b2aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusSubjectNewInput = {
  detailItemId?: string | null;
  nodeId: string;
  scale?: number | null;
  transformX?: number | null;
  transformY?: number | null;
};
export type useFocusEndMutation$variables = {
  storecastId: string;
  subject?: StorecastFocusSubjectNewInput | null;
};
export type useFocusEndMutation$data = {
  readonly dashboard: {
    readonly setNewFocus: {
      readonly subject: {
        readonly detailItemId: string | null;
        readonly nodeId: string;
      };
    } | null;
    readonly setTemporaryScreenId: {
      readonly id: string;
    };
  };
};
export type useFocusEndMutation = {
  response: useFocusEndMutation$data;
  variables: useFocusEndMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subject"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "subject",
            "variableName": "subject"
          }
        ],
        "concreteType": "StorecastNewFocus",
        "kind": "LinkedField",
        "name": "setNewFocus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastNewFocusSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detailItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "setTemporaryScreenId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFocusEndMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFocusEndMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d1ee5bae5d66ca8b9a0a899b28fbf62",
    "id": null,
    "metadata": {},
    "name": "useFocusEndMutation",
    "operationKind": "mutation",
    "text": "mutation useFocusEndMutation(\n  $storecastId: ID!\n  $subject: StorecastFocusSubjectNewInput\n) {\n  dashboard(dashboardId: $storecastId) {\n    setNewFocus(subject: $subject) {\n      subject {\n        nodeId\n        detailItemId\n      }\n    }\n    setTemporaryScreenId {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3818298fd59bafb9a2058e5e4b3c3486";

export default node;
